import { CmsDirectDebitPage } from '../../models/cms/cms-direct-debit-page.type';
import { mockCmsDirectDebitBankInstruction } from './cms-direct-debit-bank-instruction.mock';
import { mockCmsDirectDebitForm } from './cms-direct-debit-form.mock';
import { mockCmsDirectDebitGuaranteePanel } from './cms-direct-debit-guarantee-panel.mock';
import { mockCmsDirectDebitInstructionConfirmation } from './cms-direct-debit-instruction-confirmation.mock';
import { mockCmsProtectionStartSummaryPanelBoilers } from './cms-protection-start-summary-panel-boilers.mock';
import { mockCmsProtectionStartSummaryPanelWhiteGoods } from './cms-protection-start-summary-panel-white-goods.mock';

export const mockCmsDirectDebitPage: CmsDirectDebitPage = {
  ...mockCmsDirectDebitBankInstruction,
  ...mockCmsDirectDebitForm,
  ...mockCmsDirectDebitGuaranteePanel,
  ...mockCmsDirectDebitInstructionConfirmation,
  ...mockCmsProtectionStartSummaryPanelBoilers,
  ...mockCmsProtectionStartSummaryPanelWhiteGoods,
  pageTitle: 'Set up your direct debit',
};
